import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Avatar,
  Badge,
  Box,
  IconButton,
  Stack,
  Toolbar,
  Tooltip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import UnfoldMoreOutlinedIcon from "@mui/icons-material/UnfoldMoreOutlined";
import AccountMenu from "../AccountMenu/AccountMenu";
import ClubLogo from "../ClubLogo";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { useTranslation } from "../../context/Internationalization";
import { colors } from "../../theme/colors";
import { getStorage } from "../../auth/utils";
import {
  ACCOUNT_SETTINGS_ROUTE,
  NOTIFICATIONS_ROUTE,
  ROOT_ROUTE,
} from "../../routes";

const { Grey, Base } = colors;

const TopBar = ({ handleDrawerToggle, handleLogout, invitations, user }) => {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const impersonate = getStorage().getItem("impersonate");
  const hasClub = Boolean(user?.club?._id);

  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuClose = () => setAnchorElUser(null);
  const handleOpenAccountSettings = () => {
    handleMenuClose();
    navigate(ACCOUNT_SETTINGS_ROUTE);
  };

  return (
    <AppBar
      component="nav"
      sx={{
        display: { xs: "flex", lg: "none" },
        backgroundColor: Base.Black,
        marginTop: impersonate ? `${Math.max(24 - scrollPosition, 0)}px` : 0,
      }}
    >
      <Toolbar>
        <Tooltip title={t("menu")}>
          <IconButton
            color="primary"
            aria-label={t("menu")}
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, color: Grey[500] }}
          >
            <MenuIcon />
          </IconButton>
        </Tooltip>
        <IconButton onClick={() => navigate(ROOT_ROUTE)} aria-label={t("club")}>
          <ClubLogo club={user?.club} />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" alignItems="center" spacing={2}>
          {hasClub && (
            <Tooltip title={t("notifications")}>
              <IconButton
                aria-label={t("notifications")}
                onClick={() => navigate(NOTIFICATIONS_ROUTE)}
                sx={{ color: Grey[500] }}
              >
                <Badge badgeContent={invitations || 0} color="error">
                  <NotificationsOutlinedIcon sx={{ width: 24, height: 24 }} aria-hidden="true" />
                </Badge>
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title={t("user")}>
            <IconButton
              aria-label={t("open_account_menu")}
              aria-haspopup="menu"
              aria-expanded={Boolean(anchorElUser)}
              onClick={(event) => setAnchorElUser(event.currentTarget)}
              sx={{ padding: 0 }}
            >
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Avatar
                  src={user?.photo || undefined}
                  alt=""
                  sx={{ width: 30, height: 30, fontSize: 14 }}
                >
                  {(user?.firstName || "").charAt(0)}
                  {(user?.lastName || "").charAt(0)}
                </Avatar>
                <UnfoldMoreOutlinedIcon sx={{ color: Grey[400], fontSize: 20 }} />
              </Stack>
            </IconButton>
          </Tooltip>
          <AccountMenu
            anchorEl={anchorElUser}
            open={Boolean(anchorElUser)}
            onClose={handleMenuClose}
            onOpenSettings={handleOpenAccountSettings}
            onLogout={handleLogout}
            showSettings={!impersonate}
          />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
